var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 17.75C11.5 15.9551 12.9551 14.5 14.75 14.5H16C16.4142 14.5 16.75 14.1642 16.75 13.75C16.75 13.3358 16.4142 13 16 13H14.75C12.1266 13 10 15.1266 10 17.75V18V24V24.25C10 26.8734 12.1266 29 14.75 29H23.25C25.8734 29 28 26.8734 28 24.25V23C28 22.5858 27.6642 22.25 27.25 22.25C26.8358 22.25 26.5 22.5858 26.5 23V24.25C26.5 26.0449 25.0449 27.5 23.25 27.5H14.75C12.9551 27.5 11.5 26.0449 11.5 24.25V24H13C14.1298 24 15.1137 23.3755 15.6254 22.4528C15.8641 22.0224 16 21.5271 16 21C16 19.3431 14.6569 18 13 18H11.5V17.75ZM11.5 19.5V22.5H13C13.8284 22.5 14.5 21.8284 14.5 21C14.5 20.1716 13.8284 19.5 13 19.5H11.5Z",
    fill: "#6D757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0311 10.3313C23.5947 9.88956 24.4053 9.88956 24.9689 10.3313L28.4358 13.0486C29.5487 13.9209 28.9048 15.6487 27.4669 15.6487H26.1863L25.3437 20.8957C25.2416 21.531 24.671 22 24 22C23.329 22 22.7584 21.531 22.6563 20.8957L21.8137 15.6487H20.5331C19.0952 15.6487 18.4513 13.9209 19.5642 13.0486L23.0311 10.3313Z",
    fill: "#6D757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0311 10.3313C23.5947 9.88956 24.4053 9.88956 24.9689 10.3313L28.4358 13.0486C29.5487 13.9209 28.9048 15.6487 27.4669 15.6487H26.1863L25.3437 20.8957C25.2416 21.531 24.671 22 24 22C23.329 22 22.7584 21.531 22.6563 20.8957L21.8137 15.6487H20.5331C19.0952 15.6487 18.4513 13.9209 19.5642 13.0486L23.0311 10.3313ZM27.4669 14.183L24 11.4657L20.5331 14.183L21.8137 14.183C22.5688 14.183 23.2111 14.7108 23.3259 15.4258L24 19.6233L24.6741 15.4258C24.7889 14.7108 25.4312 14.183 26.1863 14.183H27.4669Z",
    fill: "#6D757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdraw);
export default __webpack_public_path__ + "static/media/icon-withdraw.0e419401b2fe0397d2fab8a5b7534f38.svg";
export { ForwardRef as ReactComponent };